/**
 * @file 活动页
 * @author wence
 * */
import React, {Component, Fragment} from 'react';
import cn from 'classnames';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Modal} from 'antd-mobile';
import {
    fetchActivityGetService,
    fetchInstanceGetInstance,
    fetchApimealPay,
    fetchPayInfo,
    fetchRealName
} from '../../actions/buyAction';

import './index.less';

const payStatus = {
    pay: 0, // 领取成功
    payBind: 1, // 领取成功为绑定手机号
    hasPay: 2 // 已经领取过
};
class Buy extends Component {
    static propTypes = {
        userLoginstate: PropTypes.object,
        activityGetService: PropTypes.object,
        instanceGetinstance: PropTypes.object,
        fetchApimealPay: PropTypes.func,
        fetchActivityGetService: PropTypes.func,
        fetchInstanceGetInstance: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            modal1: false,
            modal2: false,
            toast: false,
            toastTitle: '',
            lookUrl: '',
            status: -1,
            payInfo: {},
            authType: 0, // 是不是企业认证

            loginUrl: this.loginUrl()
        };

        this.renders = [
            this.renderNormalCard,
            this.renderLargeCard,
            this.renderBuyBindedCard
        ];
    }

    componentWillMount() {
        if (this.isPC()) {
            location.href = `/activity/buy${location.search}`;
        }
    }

    fetchBuyData = nextUser => {
        if (nextUser.status === 0) {
            this.props.fetchInstanceGetInstance().then(data => {
                let key = Object.keys(data.data.data)[0];
                this.props.fetchActivityGetService({'instance_id': key});

                this.getPayInfo({'instance_id': key});
            });
        } else if (nextUser.status === 401) {
            location.href = this.state.loginUrl;
        } else {
            this.props.fetchActivityGetService();
        }
    }

    getPayInfo = async params => {
        const res = await fetchPayInfo(params);

        if (res.status === 0) {

            if (res.data.is_buy === 0) {
                const service = res.data && res.data.service || {};
                this.payFristAction({
                    'instance_id': params.instance_id,
                    'service_id': service.service_id,
                    'meal_id': service.meal_id
                });
            }
            else {
                this.setState({status: payStatus.hasPay});
            }

            this.setState({payInfo: res.data});
        }
        else if (res.status === 401) {
            location.href = this.state.loginUrl;
        }
        else if (res.description) {
            this.setState({
                toastTitle: res.description,
                toast: true
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        let nextUser = nextProps.userLoginstate;
        if (!Object.is(nextUser, this.props.userLoginstate)) {
            this.fetchBuyData(nextUser);
        }
    }

    onClose = key => () => {
        this.setState({
            [key]: false
        });
    };

    renderBuySuccessBody = () => {
        const status = this.state.status || 0;
        return (
            <Fragment>
                <div className="sass-buy-success-container large">
                    <div className="saas-buy-success">
                        {this.renders[status] && this.renders[status]()}
                    </div>
                </div>

                <div className="saas-buy-hint">
                    试用更多安全产品
                </div>
            </Fragment>
        );
    }

    renderNormalCard = (isLarge, isBind, isBuy) => {
        const serviceInfo = this.state.payInfo.service || {};

        return (
            <div className={cn('saas-buy-success-bg', {'normal': !isBind, 'large-margin': isLarge, 'error': isBind})}>
                <div className={cn('saas-buy-success-card', {large: isLarge})}>
                    <div className="saas-buy-item-label">产品名称</div>
                    <div
                        className="saas-buy-item-value"
                        style={{marginBottom: '.3rem'}}>{serviceInfo.name}</div>

                    <div className="saas-buy-item-label">请求次数</div>
                    <div
                        className="saas-buy-item-value"
                        style={{marginBottom: '.3rem'}}>{isBuy ? '-' : serviceInfo.capacity}</div>

                    <div className="saas-buy-item-label">有效期</div>
                    <div className="saas-buy-item-value">{isBuy ? '-' : serviceInfo.time}</div>

                    <a href={`/console/#/inquires/${serviceInfo.service_id}`} className="saas-buy-item-btn">查看详情</a>

                    <div className="sass-buy-item-des">
                        <span>绑定默认联系方式，再申请免费试用可享受请求次数和有效期翻倍。</span>
                        <a className="saas-buy-item-des-bind" href="/console/#/userCenter">立即绑定</a>
                    </div>
                </div>
            </div>
        );
    }

    renderLargeCard = () => {
        return this.renderNormalCard(true);
    }

    renderBuyBindedCard = () => {
        const serviceInfo = this.state.payInfo.service || {};

        if (this.state.payInfo && this.state.payInfo.is_bind) {
            return this.renderNormalCard(false, true, this.state.payInfo.is_buy);
        }

        return (
            <div className="saas-buy-success-bg error">
                <div className="saas-buy-success-card error">
                    <div className="saas-buy-item-label">产品名称</div>
                    <div
                        className="saas-buy-item-value"
                        style={{marginBottom: '.3rem'}}>{serviceInfo.name}</div>

                    <div className="saas-buy-item-label">请求次数</div>
                    <div
                        className="saas-buy-item-value"
                        style={{marginBottom: '.3rem'}}>{this.state.payInfo.is_buy ? '-' : serviceInfo.capacity}</div>

                    <div className="sass-buy-item-des error">
                        <span>绑定默认联系方式，享受更优质服务。</span>
                        <a className="saas-buy-item-des-bind" href="/console/#/userCenter">立即绑定</a>
                    </div>
                </div>
            </div>
        );
    }

    hmt() {
        try {
            window._hmt.push(['_trackEvent', 'gmplugin', 'use', 'mobile']);
        }
        catch (e) {
            return;
        }
    }

    payFristAction = params => {
        this.props.fetchApimealPay(params).then(data => {
            if (data.data.status === 0) { // 购买成功
                this.hmt();
                this.setState({
                    status:
                        this.state.payInfo.is_bind
                            ? payStatus.pay
                            : payStatus.payBind
                });
                this.props.fetchActivityGetService({'instance_id': params.instance_id});
            } else if (data.data.status === 404008) { // 未实名
                fetchRealName({'instance_id': params.instance_id}).then(res => {
                    this.setState({
                        modal1: true,
                        authType: res && res.data && res.data['auth_type'] || 0
                    });
                });
            }
            else if (data.data.description) {
                this.setState({
                    toastTitle: data.data.description,
                    toast: true
                });
            }
        });
    }

    payAction = item => {
        const {activityGetService, instanceGetinstance, userLoginstate} = this.props;
        let loginUrl = this.state.loginUrl;
        if (item.is_buy) {
            return false;
        }

        if (!this.isEmptyobj(activityGetService) && userLoginstate.status === 0) {
            let key = Object.keys(instanceGetinstance.data)[0];
            let json = {
                'instance_id': key,
                'service_id': item.service_id,
                'meal_id': item.meal_id
            };

            this.props.fetchApimealPay(json).then(data => {
                if (data.data.status === 0) { // 购买成功
                    this.hmt();
                    this.props.fetchActivityGetService({'instance_id': key});
                    this.setState({
                        modal2: true,
                        lookUrl: item.url
                    });
                } else if (data.data.status === 404008) { // 未实名
                    fetchRealName({'instance_id': key}).then(res => {
                        this.setState({
                            modal1: true,
                            authType: res && res.data && res.data['auth_type'] || 0
                        });
                    });
                } else if (data.data.status === 404008) { // 未登录
                    location.href = loginUrl;
                }
                else if (data.data.description) {
                    this.setState({
                        toastTitle: data.data.description,
                        toast: true
                    });
                }
            });
        } else {
            location.href = loginUrl;
        }
    }
    render() {
        const {activityGetService} = this.props;
        let {modal1, modal2, lookUrl} = this.state;

        return (
            <div className={'saas-buy'}>
                {this.renderBuySuccessBody()}
                <div className="saas-buy-pro">
                    {!this.isEmptyobj(activityGetService)
                        ? activityGetService.data.map((item, index) => {
                            return <div
                                className="saas-buy-item"
                                key={index}
                            >
                                <div className="saas-buy-name">
                                    <span className={item.is_hot ? 'hot' : null}>{item.service_name}</span>
                                    {item.is_hot ? <i className="saas-buy-hot" /> : null}
                                </div>
                                <div className="saas-buy-text">
                                    {item.service_desc}
                                </div>
                                <div className="saas-buy-info">
                                    <a href={item.url} target="_blank">查看详情 <i /></a>
                                </div>
                                <div className="saas-buy-item-hint">
                                    <span>免费体验时长：</span>
                                    <span>{item.is_buy ? '-' : item.capacity}</span>
                                </div>
                                <div
                                    className={item.is_buy ? 'saas-buy-btn disable' : 'saas-buy-btn'}
                                    onClick={this.payAction.bind(this, item)}

                                >
                                    {item.is_buy ? '已领取' : '免费领取'}
                                </div>
                            </div>;
                        })
                        : null
                    }
                </div>

                <Modal
                    visible={modal1}
                    transparent
                    maskClosable={true}
                    className={'saas-attest'}
                    onClose={this.onClose('modal1')}
                >
                    <div className={'hint'}>
                        您的账号还没有认证，认证后才能购买哦！
                    </div>
                    <a
                        className={'saas-buy-btn'}
                        href={this.state.authType === 0
                            ? this.userCenterUrl()
                            : '/console/#/attestation'
                        }
                        // target={'_blank'}
                        onClick={() => {
                            this.setState({
                                modal1: false
                            });
                        }}
                    >
                        去认证
                    </a>
                </Modal>

                <Modal
                    visible={modal2}
                    transparent
                    maskClosable={false}
                    className={'saas-attest'}
                    onClose={this.onClose('modal2')}
                >
                    <div className={'hint'}>
                        购买成功，可前往控制台查看使用说明
                    </div>
                    <div className={'operate'}>
                        <a
                            className={'saas-buy-btn hint-btn'}
                            href={lookUrl}
                            target={'_blank'}
                            onClick={() => {
                                this.setState({
                                    modal2: false
                                });
                            }}
                        >
                            去控制台
                        </a>
                        <div
                            className={'saas-buy-btn'}
                            onClick={() => {
                                this.setState({
                                    modal2: false
                                });
                            }}
                        >
                            继续购买
                        </div>
                    </div>
                </Modal>

                <Modal
                    visible={this.state.toast}
                    transparent
                    maskClosable={false}
                    wrapClassName="spu-modal-confirm"
                    className={'saas-attest'}
                    onClose={this.onClose('modal2')}
                >
                    <div className={'hint'}>
                        {this.state.toastTitle}
                    </div>
                    <div className={'operate'}>
                        <a
                            className={'saas-buy-btn'}
                            onClick={(e) => {
                                e.preventDefault();
                                this.setState({
                                    toast: false,
                                    toastTitle: ''
                                });
                            }}
                        >
                            关闭
                        </a>
                    </div>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        userLoginstate: state.userLoginstate,
        activityGetService: state.activityGetService,
        instanceGetinstance: state.instanceGetinstance
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchApimealPay: obj => fetchApimealPay(dispatch, obj),
        fetchActivityGetService: obj => fetchActivityGetService(dispatch, obj),
        fetchInstanceGetInstance: () => fetchInstanceGetInstance(dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Buy);



// WEBPACK FOOTER //
// ./src/containers/buy/activity.js